var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMkrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127024044456826526290000012886099524539873169_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000129197840078170682630000001159238914424841623_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.1,
    y1: 715.5,
    x2: 441.1,
    y2: -165.7,
    gradientTransform: "matrix(1 0 0 -1 0 716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4FA89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6ACEBB"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.3,573.3V365.9l157.3,118.4v89h40.1v-97.4c0-7.3-3.5-14.2-9.3-18.7L221.6,313.7 c-10.4-7.7-25.1-5.6-32.9,4.9c-3,4-4.6,8.9-4.6,13.9v240.9h40.2V573.3z M659.2,573.3V365.9L501.9,484.3v89h-40.1v-97.4 c0-7.3,3.5-14.2,9.3-18.7l190.7-143.5c10.4-7.7,25.1-5.6,32.9,4.9c3,4,4.6,8.9,4.6,13.8v240.9L659.2,573.3L659.2,573.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkrIcon);
export default __webpack_public_path__ + "static/media/mkr_icon.539ed6d06f68bd62f4df50254cfdf223.svg";
export { ForwardRef as ReactComponent };